<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h2 class="display-4 text-white font-weight-light">Welcome to</h2>
              <h1 class="display-2 text-white font-weight-bold mb-0">
                Indian Commercial Pilots Association
              </h1>
              <h2 class="display-4 text-white font-weight-light">
                UNITY ◈ INTEGRITY ◈ DIGNITY ◈ SAFETY
              </h2>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Sign in with credentials</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email"
                    v-model="model.userName"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 5 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  >
                  </base-input>

                  <b-form-checkbox v-model="model.rememberMe"
                    >Remember me</b-form-checkbox
                  >
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >Sign in</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/auth/forgotpassword" class="text-light"
                ><small>Forgot password? </small></router-link
              >
              <div class="d-inline-flex p-3 m-b2">
                <b-form-radio
                  v-model="selected"
                  name="env"
                  value="development"
                  class="mr-2"
                  >DEV</b-form-radio
                >
                <b-form-radio v-model="selected" name="env" value="production"
                  >PROD</b-form-radio
                >
              </div>
            </b-col>
            <!-- <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light"
                ><small>Create new account</small></router-link
              >
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { APP_CONSTANT } from "../../constants/app.constant";
let api = () => import("../../services/api.service");
import swal from "sweetalert2";
export default {
  data() {
    return {
      model: {
        userName: "",
        password: "",
        rememberMe: false
      },
      selected: "production",
      flag: false
    };
  },
  created() {
    this.setEnv(this.selected);
  },
  watch: {
    selected: function(val) {
      this.setEnv(val);
      api = () => {};
      if (this.flag) window.location.reload();
    }
  },
  methods: {
    ...mapActions("user", ["setUserData", "setJWTToken", "setEnv"]),
    onSubmit() {
      if (!this.flag) this.flag = true;
      let api = () => import("../../services/api.service");
      api().then(({ API }) => {
        API.LOGIN({
          userName: this.model.userName,
          password: this.model.password
        })
          .then(res => {
            try {
              if (res) {
                if (res.data.ok) {
                  if (
                    res.data.result.userData.role.includes("admin") ||
                    res.data.result.userData.role.includes("manager") ||
                    res.data.result.userData.role.includes("superAdmin")
                  ) {
                    this.setUserData(res.data.result.userData);
                    this.setJWTToken(res.data.result.auth_token);
                    localStorage.setItem(
                      APP_CONSTANT.USER_ACCESS_TOKEN,
                      res.data.result.auth_token
                    );
                    localStorage.setItem(
                      APP_CONSTANT.USER_INFO,
                      JSON.stringify(res.data.result.userData)
                    );
                    this.$router.push(
                      this.$route.query.redirect || "/dashboard"
                    );
                  } else throw "You are not authorized!";
                }
              } else {
                throw err;
              }
            } catch (e) {
              swal.fire({
                title: `${
                  e && e.response && e.response.data && e.response.data.message
                    ? e.response.data.message
                    : "Something went wrong!"
                }`,
                buttonsStyling: false,
                type: "warning",
                confirmButtonClass: "btn btn-danger btn-fill"
              });
            }
          })
          .catch(err => {
            api = () => {};
            swal.fire({
             title: `${
                  err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : "Something went wrong!"
                }`,
              buttonsStyling: false,
              type: "error",
              confirmButtonClass: "btn btn-danger btn-fill"
            });
          });
      });
      // this will be called only after form is valid. You can do api call here to login
    }
  }
};
</script>
